import { FormField, MaskedInput } from 'grommet';
import { emailMask, emailValidation } from '@utils/masks';

export const Email = (): JSX.Element => {
  return (
    <FormField
      name="email"
      htmlFor="email"
      label="Email"
      validate={(value) => emailValidation(value)}
      required
    >
      <MaskedInput
        id="email"
        name="email"
        mask={emailMask}
      />
    </FormField>
  );
};
